import {
  ProductInstanceDTO,
  RefinancedLoanDTO,
} from "@smartx/mikro-vt-client-api"
import { useTranslation } from "react-i18next"
import { IField } from "../../../components/DataList/DataList"
import { productCodes } from "../../../functions/caseHelper"
import { DataListComponent } from "../../../Shared"
import { isEhProduct } from "../../../functions/helpers"

interface IOverviewRefinancedLoan {
  refinancedLoan: RefinancedLoanDTO
  product: ProductInstanceDTO
}

const OverviewRefinancedLoan: React.FC<IOverviewRefinancedLoan> = ({
  refinancedLoan,
  product,
}) => {
  const { t } = useTranslation()

  const isEh = isEhProduct(product)
  const isExit = product?.productCode === productCodes.EXIT
  const isEsetiLoanType = refinancedLoan.loanType === "ESETI_HITEL"

  const fieldArr: Array<IField> = [
    {
      label: t("case.fields.refinancedLoan.loanType"),
      value: refinancedLoan.loanType,
      fieldType: "CVT",
      list:
        isEh || isExit
          ? "MIKRO_REFINANCED_LOAN_TYPES_EH"
          : "MIKRO_REFINANCED_LOAN_TYPES_FH",
    },
    {
      label: t("case.fields.refinancedLoan.bankName"),
      value: refinancedLoan.bankName,
      fieldType: "text",
    },
    {
      label: t("case.fields.refinancedLoan.loanId"),
      value: refinancedLoan.loanId,
      fieldType: "text",
    },
    isExit
      ? null
      : {
          label: t("case.fields.refinancedLoan.loanKhrId"),
          value: refinancedLoan.loanKhrId,
          fieldType: "text",
        },
    {
      label: t("case.fields.refinancedLoan.loanContractAmount"),
      value: refinancedLoan.loanContractAmount,
      fieldType: "number",
    },
    isEh || (isExit && isEsetiLoanType)
      ? {
          label: t("case.fields.refinancedLoan.loanRemainingAmount"),
          value: refinancedLoan.loanRemainingAmount,
          fieldType: "number",
        }
      : null,
    {
      label: t("case.fields.refinancedLoan.accountNumber"),
      value: refinancedLoan.accountNumber,
      fieldType: "bankAccount",
    },
  ]

  return <DataListComponent dataList={fieldArr.filter(Boolean)} />
}

export default OverviewRefinancedLoan
